export default "https://cdn-static.gokick.com/assets/16eea26e4b02b6fb7531e57480884e04972270e8/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";